import React from 'react';
import { UID } from 'react-uid';

const SVGStyle = {
  mixBlendMode: 'multiply',
};

const EiPremierIcon = ({
  title = 'EI Premier',
  decorative = true,
  className,
  size,
}) => (
  <UID>
    {(uid) => (
      <div style={{ width: size, height: size }} className={className}>
        <svg
          role="img"
          aria-hidden={decorative}
          aria-labelledby={uid}
          width="147"
          height="95"
          viewBox="0 0 147 95"
        >
          <title id={uid}>{title}</title>
          <defs>
            <linearGradient
              id="p-a"
              x1="50%"
              x2="100.218%"
              y1="22.498%"
              y2="16.258%"
            >
              <stop offset="0%" stopColor="#4D7CFE" />
              <stop offset="100%" stopColor="#84B3FF" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="p-b"
              x1="34.169%"
              x2="1.197%"
              y1="26.892%"
              y2="113.574%"
            >
              <stop offset="0%" stopColor="#FFDE92" />
              <stop offset="100%" stopColor="#FF931E" />
            </linearGradient>
            <linearGradient id="p-c" x1="50%" x2="50%" y1="0%" y2="100%">
              <stop offset="0%" stopColor="#E5ECFF" />
              <stop offset="100%" stopColor="#B5C9FF" />
            </linearGradient>
            <linearGradient
              id="p-d"
              x1="84.076%"
              x2="113.287%"
              y1="83.458%"
              y2="0%"
            >
              <stop offset="0%" stopColor="#F5F9FF" stopOpacity="0" />
              <stop offset="100%" stopColor="#8BA3CA" />
            </linearGradient>
            <linearGradient
              id="p-e"
              x1="84.013%"
              x2="113.171%"
              y1="83.458%"
              y2="0%"
            >
              <stop offset="0%" stopColor="#F5F9FF" stopOpacity="0" />
              <stop offset="100%" stopColor="#8BA3CA" />
            </linearGradient>
            <linearGradient
              id="p-f"
              x1="86.95%"
              x2="118.624%"
              y1="83.458%"
              y2="0%"
            >
              <stop offset="0%" stopColor="#F5F9FF" stopOpacity="0" />
              <stop offset="100%" stopColor="#8BA3CA" />
            </linearGradient>
            <linearGradient
              id="p-g"
              x1="86.955%"
              x2="118.633%"
              y1="83.458%"
              y2="0%"
            >
              <stop offset="0%" stopColor="#F5F9FF" stopOpacity="0" />
              <stop offset="100%" stopColor="#8BA3CA" />
            </linearGradient>
          </defs>
          <g fill="none" fillRule="evenodd" transform="translate(-1 -5)">
            <g
              fill="#F1F5FF"
              opacity=".5"
              transform="matrix(-1 0 0 1 147.753 5.66)"
            >
              <rect width="102.655" height="24.774" x="3.779" rx="12.387" />
              <rect
                width="116.643"
                height="23.899"
                x="29.6"
                y="70.44"
                rx="11.95"
              />
              <rect
                width="116.643"
                height="48.428"
                x="21.32"
                y="24.468"
                rx="24.2"
              />
              <ellipse cx="7.95" cy="62.22" rx="7.873" ry="7.884" />
              <ellipse cx="15.824" cy="77.697" rx="4.082" ry="4.088" />
              <ellipse cx="125.957" cy="11.95" rx="11.966" ry="11.95" />
            </g>
            <g fillRule="nonzero">
              <path
                fill="#00173E"
                d="M105.745 48.199L76.588 23.362a4.044 4.044 0 0 0-5.235 0L42.196 48.2h63.549z"
              />
              <path
                fill="#00173E"
                d="M42.196 48.199l29.631 16.869a4.36 4.36 0 0 0 4.306 0l29.632-16.87h-63.57z"
              />
              <path
                fill="url(#p-a)"
                d="M10.264 7.27h44.127v50.91l-44.127-2.238z"
                style={SVGStyle}
                transform="translate(42.196 21.798)"
              />
              <path fill="#FFF" d="M51.013 24.943h43V77.74h-43z" />
              <path
                fill="url(#p-b)"
                d="M34.54 15.292c.658-.65.894-1.618.61-2.5a2.437 2.437 0 0 0-1.955-1.665l-8.614-1.26a1.217 1.217 0 0 1-.918-.666l-3.851-7.846A2.432 2.432 0 0 0 17.634 0c-.923 0-1.766.525-2.178 1.355L11.6 9.201c-.177.36-.518.608-.912.667l-8.614 1.26a2.437 2.437 0 0 0-1.954 1.664 2.455 2.455 0 0 0 .61 2.5l6.235 6.115c.277.284.4.686.328 1.077L5.84 31.106a2.452 2.452 0 0 0 .97 2.388c.748.546 1.739.618 2.558.187l7.701-4.073a1.211 1.211 0 0 1 1.132 0l7.701 4.073a2.423 2.423 0 0 0 2.991-.59c.46-.55.657-1.276.538-1.985l-1.454-8.622c-.069-.396.06-.801.346-1.083l6.218-6.109z"
                transform="translate(54.791 31.232)"
              />
              <path
                fill="url(#p-c)"
                d="M31.773 44.496L63.549 26.4v36.192H0V26.4z"
                transform="translate(42.196 21.798)"
              />
              <path
                fill="#001757"
                d="M42.326 84.09l31.588-17.87.098.17-31.588 17.87z"
              />
              <path
                fill="#001757"
                d="M73.91 66.377l.098-.168 31.551 17.795-.098.168z"
              />
            </g>
            <path
              fill="url(#p-d)"
              fillRule="nonzero"
              d="M95.257 20.635a.986.986 0 0 1 .078-1.173l11.026-14.985a.979.979 0 0 1 1.335-.048.986.986 0 0 1 .145 1.332L96.815 20.746c-.123.14-.282.244-.46.3a.98.98 0 0 1-1.098-.41z"
              transform="rotate(170 101.567 12.637)"
            />
            <path
              fill="url(#p-d)"
              fillRule="nonzero"
              d="M40.465 20.635a.986.986 0 0 1 .079-1.173L51.569 4.477a.979.979 0 0 1 1.335-.048.986.986 0 0 1 .145 1.332L42.024 20.746c-.124.14-.283.244-.46.3a.98.98 0 0 1-1.099-.41z"
              transform="scale(1 -1) rotate(-10 -97.67 0)"
            />
            <path
              fill="url(#p-e)"
              fillRule="nonzero"
              d="M48.844 18.603a.987.987 0 0 1 .078-1.174L59.938 2.443a.978.978 0 0 1 1.334-.047c.389.338.453.92.146 1.333L50.402 18.715c-.123.14-.282.243-.46.3a.98.98 0 0 1-1.098-.412z"
              transform="scale(1 -1) rotate(-33 19.348 0)"
            />
            <path
              fill="url(#p-f)"
              fillRule="nonzero"
              d="M90.327 20.88a.993.993 0 0 1-.147-1.147l1.715-2.514c2.232-3.273 3.522-4.9 3.869-4.88a.95.95 0 0 1 .84-.602.946.946 0 0 1 .885.533.988.988 0 0 1-.109 1.044l-5.567 7.389a.937.937 0 0 1-.372.374.938.938 0 0 1-1.114-.197z"
              transform="rotate(166 93.825 16.458)"
            />
            <path
              fill="url(#p-g)"
              fillRule="nonzero"
              d="M37.572 25.434a.992.992 0 0 1-.145-1.148l1.716-2.515c2.235-3.275 3.525-4.903 3.872-4.884a.951.951 0 0 1 .842-.603.944.944 0 0 1 .883.533.989.989 0 0 1-.11 1.045l-5.572 7.393a.94.94 0 0 1-.372.375.937.937 0 0 1-1.114-.196z"
              transform="scale(1 -1) rotate(23 144.335 0)"
            />
            <path
              fill="#E5A000"
              fillRule="nonzero"
              d="M49.136 32.973c-.8 0-1.583-.215-2.268-.621a.48.48 0 0 1-.264-.426.48.48 0 0 1 .263-.427.494.494 0 0 1 .506.034 3.462 3.462 0 0 0 4.22-.545 3.329 3.329 0 0 0 .416-4.169.474.474 0 0 1-.045-.495.49.49 0 1 1 .863-.024c.875 1.331.94 3.026.17 4.417a4.403 4.403 0 0 1-3.86 2.256z"
            />
            <path
              fill="#FF931E"
              fillRule="nonzero"
              d="M115.318 51.987a.568.568 0 0 1-.505-.344c-.742-1.628-2.03-2.877-3.594-3.482-.294-.115-.448-.47-.344-.793a.6.6 0 0 1 .287-.352c.135-.07.29-.08.43-.025 1.84.71 3.356 2.178 4.23 4.092.137.308.025.68-.252.837a.52.52 0 0 1-.252.067z"
            />
            <path
              fill="#C8D7EE"
              fillRule="nonzero"
              d="M103.982 32.973a.568.568 0 0 0-.505.344c-.742 1.629-2.03 2.877-3.595 3.482-.294.115-.447.47-.343.793a.6.6 0 0 0 .287.352c.135.071.29.08.43.025 1.84-.71 3.356-2.178 4.23-4.092.137-.308.025-.68-.252-.837a.52.52 0 0 0-.252-.067z"
            />
            <path
              fill="#D6E2F5"
              fillRule="nonzero"
              d="M110.226 11.57a.66.66 0 0 1-.144.626c-1.161 1.175-1.843 2.857-1.901 4.69-.012.346-.268.593-.57.553a.576.576 0 0 1-.382-.231.727.727 0 0 1-.145-.461c.067-2.157.867-4.136 2.232-5.519.22-.218.567-.18.78.084.06.075.105.163.13.259z"
            />
            <path
              fill="#FABB2B"
              fillRule="nonzero"
              d="M89.672 29.2l-.872 2.515 3.149-1.455z"
            />
            <path
              fill="#FFDE92"
              fillRule="nonzero"
              d="M101.972 26.653l2.43-.65-2.802-1.698z"
            />
            <path
              fill="#FABB2B"
              fillRule="nonzero"
              d="M37.992 40.52l.425-3.144-3.779 2.595z"
            />
            <ellipse
              cx="56.996"
              cy="34.546"
              fill="#F28510"
              fillRule="nonzero"
              rx="1.574"
              ry="1.572"
            />
            <ellipse
              cx="45.66"
              cy="38.948"
              fill="#C8D7EE"
              fillRule="nonzero"
              rx="1"
              ry="1"
            />
            <ellipse
              cx="42.826"
              cy="27.459"
              fill="#F28510"
              fillRule="nonzero"
              rx="1"
              ry="1"
            />
            <ellipse
              cx="107.694"
              cy="41.778"
              fill="#FABB2B"
              fillRule="nonzero"
              rx="1"
              ry="1"
            />
            <ellipse
              cx="97.302"
              cy="47.753"
              fill="#FABB2B"
              fillRule="nonzero"
              rx="1.574"
              ry="1.572"
            />
          </g>
        </svg>
      </div>
    )}
  </UID>
);

export default EiPremierIcon;
